import * as yup from 'yup';

export const WhatsSchema = yup.object({
    sender: yup.string().required("Sender is required"),
    recipientNumber: yup
        .string()
        .matches(/^\d{10,15}$/, "Recipient must be a valid phone number")
        .required("Recipient number is required"),
    message: yup.string().required("Message is required"),
    startDate: yup.date().required("Start Date is required"),
    createBy: yup.string().nullable(),
    createByLead: yup.string().nullable(),
});
